<template>
    <div>
        <div v-show="showSelect" class="input-group">
            <div class="input-group-btn">
                <button type="button" class="btn btn-default blue" data-toggle="dropdown">
                    {{currentCaption}}
                    <span class="caret"></span>
                </button>
                <ul class="dropdown-menu">
                    <li v-for="(item, index) in definitions" :key="index">
                        <a href="#" v-on:click="menuSelect(item)">{{item.caption}}</a>
                    </li>
                </ul>
            </div>
            <wes-select :store="refStore" v-if="(lookupEntityName)" ref="select" :endpoint="lookupEntityName" v-on:item-selected="lookupItemSelected" v-on:options-loaded="lookupOptionsLoaded" result-fields="nome" :origem="origem"></wes-select>
        </div>
        <wes-treeview :markAllByDefault="markAllByDefault" :store="refStore" :treeview-id="treeviewId" button="circle" class="margin-top-10" ref="treeview" v-on:item-selected="itemSelected" v-on:loaded="treeViewLoaded" v-on:unloaded="treeViewUnloaded" ></wes-treeview>
    </div>
</template>
<script>
    import _ from 'lodash';
    export default {        
        props: {
            definitions: {

            },
            treeviewId: {

            }, 
            store: {

            }, 
            markAllByDefault: {

            }, 
            showSelect: {
                default: true
            },
			origem: {
			
			},
			startDate: { },
			endDate: {  }
        },
        data: function () {
            return {
                currentCaption: "",
                lookupCurrentItem: 0,
                lookupEntityName: "",
                treeviewFilterField: "",
                treeviewEntityName: "",                
                filtrarEmpresa: false,        
                refStore : {},
                firstUsage: true
            }
        },
        mounted: function () {
            this.selectDefaultMenu();
            this.refStore = this.store;            
            this.treeview = this.$refs.treeview;
        },
        methods: {   
            clear(){
                this.treeview.desmarcarAll();
            },        
            getTreeViewSelectStore() {      
                return this.store;                            
            },       
            selectDefaultMenu(){                
                if (this.definitions && this.definitions.length > 0) {                
                    var selected = this.definitions[0];
                    if(this.store !== undefined){                                                                     
                        var store = this.store;                                                                        
                        var d = _.filter(this.definitions, function(p) { return p.caption === store.tipo });
                        if(d.length === 1){                            
                            selected = d[0];
                        }
                                           
                    }                
                    this.menuSelect(selected);
                }
            },
            treeViewLoaded: function (args) {                                
                this.$emit('tree-view-loaded', args);
            },
            treeViewUnloaded: function (args) {                                
                this.$emit('tree-view-unloaded', args);
            },
            itemSelected: function (args) {                                
                this.$emit('item-selected', args);
            },
            loadTreeViewData: function () {
                 if(this.firstUsage){
                    this.firstUsage = false;
                } else {
                    this.$refs.treeview.desmarcarAll();                             
                }    
				
				if (this.treeviewEntityName === "gn_projetos") {
					if (!this.startDate || !this.endDate)
						return;

					const start = moment(this.startDate, "DD/MM/YYYY");
					const end   = moment(this.endDate, "DD/MM/YYYY");

					if (!start.isValid() || !end.isValid())
						return;

					this.$refs.treeview.loadData(
						`${this.treeviewEntityName}/${this.filtrarEmpresa}/${start.format("YYYY-MM-DD")}/${end.format("YYYY-MM-DD")}`
					);
					return;
				}

                if (this.treeviewFilterField && this.lookupCurrentItem !== undefined) {
                    this.$refs.treeview.loadData(this.treeviewEntityName + '/' + this.treeviewFilterField + '/' + this.lookupCurrentItem);
                } else if (this.treeviewFilterField && this.filtrarEmpresa) {
                    this.$refs.treeview.loadData(this.treeviewEntityName);
                } else {
                    this.$refs.treeview.loadData(this.treeviewEntityName + '/' + this.filtrarEmpresa);
                }
            },
            lookupItemSelected: function (value) {
                this.lookupCurrentItem = value;
                this.loadTreeViewData();
                var payload = {
                    choice: this.treeviewId,
                    origem: value
                };
                this.$emit('lookup-item-selected', payload);
            },
            lookupOptionsLoaded: function (options) {
                // Quando o lookup que filtra o treeview (ex.: planos gerenciais) volta
                // sem nenhum registro, o wes-select não seleciona item algum, então
                // loadTreeViewData() nunca roda e o evento 'loaded' do treeview jamais
                // dispara — o consumidor fica com o spinner girando pra sempre.
                // Aqui destravamos a UI marcando o treeview como carregado (vazio) e
                // avisamos o consumidor via 'lookup-empty' para que ele possa alertar
                // o usuário.
                if (!options || options.length === 0) {
                    this.$emit('tree-view-loaded', { choice: this.treeviewId, data: [] });
                    this.$emit('lookup-empty', { choice: this.treeviewId, caption: this.currentCaption });
                }
            },
            menuSelect: function (item) {                         
                this.currentCaption = item.caption;
                this.lookupEntityName = item.lookupEntityName;
                this.treeviewFilterField = item.treeviewFilterField;
                this.treeviewEntityName = item.treeviewEntityName;
                this.filtrarEmpresa = !!item.filtrarEmpresa;

                var payload = {
                    choice: this.treeviewId,
                    tipo: item.caption  
                };                                                                
                this.$emit('menu-item-selected', payload);                
                if (!this.lookupEntityName) {                                                      
                    this.loadTreeViewData();
                }
            },
        }
    }
</script>
<style>
    .margin-top-10{
        margin-top:10px;
    }
</style>